var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-overlay',{ref:"customOverlay",class:[_vm.isweixing ? 'sample' : 'sample2'],attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}},[_c('div',{staticClass:"name",domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }